// @flow
import React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import type {
  AvailableSettings,
  SettingType,
} from 'docs/data/integration-builder';
import {DefaultSettings, DEFAULT_SETTINGS} from './DefaultSettings';
import {ServerOnlySettings, SERVER_ONLY_SETTINGS} from './ServerOnlySettings';
import {WebOnlySettings, WEB_ONLY_SETTINGS} from './WebOnlySettings';
import {
  WebWithNextSettings,
  WEB_WITH_NEXT_SETTINGS,
} from './WebWithNextSettings';

type SettingsProps = {|
  type: SettingType,
|};

export const getAvailableSettings = (type: SettingType): AvailableSettings => {
  switch (type) {
    case 'web-only':
      return WEB_ONLY_SETTINGS;
    case 'server-only':
      return SERVER_ONLY_SETTINGS;
    case 'web-with-next':
      return WEB_WITH_NEXT_SETTINGS;
    default:
      return DEFAULT_SETTINGS;
  }
};

export const Settings = ({type}: SettingsProps) => {
  let SettingsComponent;
  switch (type) {
    case 'server-only':
      SettingsComponent = <ServerOnlySettings />;
      break;
    case 'web-only':
      SettingsComponent = <WebOnlySettings />;
      break;
    case 'web-with-next':
      SettingsComponent = <WebWithNextSettings />;
      break;
    default:
      SettingsComponent = <DefaultSettings />;
      break;
  }

  return (
    <Box
      className={classNames('Settings', type)}
      flex={{justifyContent: 'space-between', alignItems: 'center'}}
      margin={{bottom: 32, left: 32}}
    >
      {SettingsComponent}
    </Box>
  );
};
